import { useIntl } from "react-intl";

export default function DataNotFound({color = 'text-black'}) {

    const intl = useIntl();

  return (
    <div className={`text-center ${color}`}>
        <h5>{intl.formatMessage({ id: "data-not-found" })}</h5>
    </div>
  )
}
